import { createSlice } from '@reduxjs/toolkit'

export const IncomingCall = createSlice({
  name: 'incomingCall',
  initialState: {
    incomingCapToken: '',
    incomingTwilioDevice: {},
  },
  reducers: {
   
    setIncomingCapToken: (state, action) => {
      state.incomingCapToken = action.payload
    },

    setIncomingTwilioDevice: (state, action) => {
        state.incomingTwilioDevice = action.payload
    },

  },
})

// Action creators are generated for each case reducer function
export const { setIncomingCapToken, setIncomingTwilioDevice } = IncomingCall.actions

export default IncomingCall.reducer
